// Mensajes de los errores que devuelve el backend al entrar con SSO, según el
// código que agrega como ?error= a la URL de regreso (utils/sso/redireccion.js).
//
// El backend manda también su propio `message`, pero está redactado para
// soporte (trae el correo completo y un "Contacte a su administrador"), así que
// en pantalla se muestra este texto y el del backend se descarta.
//
// Los códigos salen de authenticateUserByEmail en googleAuthController.js y de
// microsoftAuthController.js, no de la guía de integración: la guía nombra
// INVALID_TOKEN y UNAUTHORIZED_DOMAIN, que no existen en el backend (son
// INVALID_*_TOKEN y DOMAIN_NOT_ALLOWED).
//
// Caen a propósito en el genérico los INVALID_*_TOKEN y MISSING_*, el texto
// libre que manda el backend cuando falla el canje del código, y una vuelta que
// no corresponde a un ingreso iniciado en este navegador: en todos lo único que
// puede hacer la persona es reintentar, que es justo lo que dice ese texto.

const MENSAJES = {
  USER_NOT_REGISTERED: (proveedor) => `Ese correo de ${proveedor} no está registrado en KÄIK.`,
  DOMAIN_NOT_ALLOWED: () => "Ese correo no pertenece a una empresa registrada en KÄIK.",
  USER_INACTIVE: () => "Tu usuario está desactivado. Contacta a soporte.",
  // Todavía no lo manda el backend: es el código que propone el instructivo
  // (claude_docs/Sso) para cuando Google no haya verificado el correo
  EMAIL_NOT_VERIFIED: (proveedor) =>
    `Tu correo de ${proveedor} no está verificado. Verifícalo en ${proveedor} e intenta nuevamente.`,
  // Lo devuelve el backend o, mientras no reciba tipo_web en la redirección, lo
  // aplica Login.vue (completarInicioSesion)
  FORBIDDEN: () => "Tu usuario no tiene acceso al administrador.",
  // El correo sí está registrado, pero el backend no pudo cargar el perfil
  // completo. No es algo que el usuario pueda resolver reintentando.
  USER_NOT_FOUND: () =>
    "Tu cuenta existe, pero no pudimos cargar tu perfil. Contacta a soporte.",
  // El backend no tiene configurado el proveedor: tampoco es culpa del usuario
  GOOGLE_NOT_CONFIGURED: () => "El ingreso con Google no está habilitado. Contacta a soporte.",
  MICROSOFT_NOT_CONFIGURED: () =>
    "El ingreso con Microsoft no está habilitado. Contacta a soporte.",
};

/**
 * @param {String} codigo - el `extensions.code` del error, si vino.
 * @param {String} proveedor - "Google" o "Microsoft", para nombrarlo en el texto.
 * @returns {String} - el mensaje para la tarjeta del login. Un código
 * desconocido, un token vencido o un error de red caen en el genérico.
 */
export function mensajeErrorSso(codigo, proveedor) {
  const mensaje = MENSAJES[codigo];
  return mensaje
    ? mensaje(proveedor)
    : `No pudimos validar tu cuenta de ${proveedor}. Intenta nuevamente.`;
}
